import { Fragment } from 'react'
import { Divider, HStack, VStack, Text } from '@gazin/ecommerce-ui'
import { paymentMethodsIconsMap } from 'src/util/payment-methods-icons'
import { PaymentMethodsEnum } from 'src/util/enums/payment-methods'
import { CreditCardInstallmentProps } from '../types'
import { formatarPreco } from 'src/util/formatar'

export const CreditCardInstallment = ({
  installments,
}: CreditCardInstallmentProps) => {
  return (
    <>
      <VStack
        w="100%"
        gap="0.75rem"
        mt="0.5rem"
        spacing={0}
        alignItems="flex-start"
        maxH={{ base: '20.75rem', md: '22.3125rem' }}
        overflow="auto"
        scrollBehavior="smooth"
        css={{
          '&::-webkit-scrollbar': {
            width: '0.375rem',
            height: '80%',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#7C8096',
            borderRadius: '3.125rem',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: '#DCDDE3',
            borderRadius: '3.125rem',
          },
        }}
        paddingRight={{ base: '0.75rem', md: '1rem' }}
        mb={{ base: 0, md: '0.5rem' }}
      >
        {installments?.map(
          ({ quantity, interestRate, amount, total }, index) => {
            const isLast = installments.length - 1 === index
            return (
              <Fragment key={`${index}${quantity}`}>
                <VStack
                  alignItems="flex-start"
                  w="100%"
                  spacing={0}
                  pb={isLast ? '0.5rem' : 0}
                >
                  <HStack
                    color="neutral.700"
                    fontSize={{ base: '0.875rem', md: '1rem' }}
                    lineHeight={{ base: '1.225rem', md: '1.4rem' }}
                    alignItems="center"
                    justifyContent="space-between"
                    w="100%"
                  >
                    <Text fontWeight={600}>
                      {quantity}
                      {' x '}
                      {formatarPreco(amount)}
                    </Text>

                    <Text color="neutral.400" ml="auto" fontWeight={700}>
                      Total{' '}
                      <Text as="span" color="neutral.700">
                        {formatarPreco(total)}
                      </Text>
                    </Text>
                  </HStack>

                  <Text
                    color="neutral.600"
                    lineHeight={{ base: '0.875rem', md: '1.05rem' }}
                    fontSize={{ base: '0.625rem', md: '0.75rem' }}
                  >
                    {interestRate
                      ? `Com juros de ${interestRate
                          .toString()
                          .replace('.', ',')}%`
                      : 'Sem juros'}
                  </Text>
                </VStack>
                {!isLast && <Divider color="#E3E3E8" mt={0} />}
              </Fragment>
            )
          }
        )}
      </VStack>
      <Divider color="#E3E3E8" display={{ base: 'block', md: 'none' }} />
      {
        <HStack
          alignItems="center"
          justifyContent="flex-start"
          w="100%"
          gap="1.125rem"
        >
          {paymentMethodsIconsMap[PaymentMethodsEnum.Credit_card]}
        </HStack>
      }
    </>
  )
}
